import { render, staticRenderFns } from "./VuetablePagination.vue?vue&type=template&id=49dca945"
import script from "./VuetablePagination.vue?vue&type=script&lang=js"
export * from "./VuetablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports